import { createSlice } from '@reduxjs/toolkit';

export const stockSettingSlice = createSlice({
  name: 'stockSetting',
  initialState: {
    categories: [],
    currentCategory: {
      id: 0,
      name: '',
      name_eng: '',
    },
    measures: [],
    currentMeasure: {
      id: 0,
      name: '',
      symbol: '',
      name_eng: '',
    },
    places: [],
    currentPlace: {
      id: 0,
      name: '',
      description: '',
    },
  },
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    addCategory: (state, action) => {
      state.categories.push(action.payload);
    },
    viewCategory: (state, action) => {
      state.currentCategory = action.payload;
    },
    resetCurrentCategory: (state) => {
      state.currentCategory = {
        id: 0,
        name: '',
        name_eng: '',
      };
    },
    setMeasures: (state, action) => {
      state.measures = action.payload;
    },
    addMeasure: (state, action) => {
      state.measures.push(action.payload);
    },
    viewMeasure: (state, action) => {
      state.currentMeasure = action.payload;
    },
    resetCurrentMeasure: (state) => {
      state.currentMeasure = {
        id: 0,
        name: '',
        symbol: '',
        name_eng: '',
      };
    },
    setPlaces: (state, action) => {
      state.places = action.payload;
    },
    addPlace: (state, action) => {
      state.places.push(action.payload);
    },
    viewPlace: (state, action) => {
      state.currentPlace = action.payload;
    },
    resetCurrentPlace: (state) => {
      state.currentPlace = {
        id: 0,
        name: '',
        description: '',
      };
    },
  },
});

export const {
  setCategories,
  setMeasures,
  setPlaces,
  addCategory,
  addMeasure,
  addPlace,
  resetCurrentCategory,
  resetCurrentMeasure,
  resetCurrentPlace,
  viewCategory,
  viewMeasure,
  viewPlace,
} = stockSettingSlice.actions;

export const selectCategories = (state) => state.stockSetting.categories;
export const selectMeasures = (state) => state.stockSetting.measures;
export const selectPlaces = (state) => state.stockSetting.places;
export const selectCurrentCategory = (state) => state.stockSetting.currentCategory;
export const selectCurrentMeasure = (state) => state.stockSetting.currentMeasure;
export const selectCurrentPlace = (state) => state.stockSetting.currentPlace;

export default stockSettingSlice.reducer;
